export default "./dist/stdassets/images/icons/select-features.png";